export const AnalyticsWeightings = {
    customerTestimonialPoints: 2,
    dataSheetPoints: 2,
    webinarPoints: 2,
    caseStudyPoints: 2,
    customizationGuidePoints: 2,
    whitePaperPoints: 2,
    appInstallPoints: 5,
    clickPoints: 2,
    demoPoints: 4,
    favListingPoints: 4,
    likeReviewPoints: 3,
    negativeReviewPoints: -3,
    positiveReviewPoints: 5,
    pageViewPoints: 2,
    searchPoints: 0,
    screenShotPoints: 3,
    testDrivePoints: 4,
    learnMorePoints: 2,
    unInstallPoints: 0,
    defaultPoints: 0,
};
